import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../components/shared/SectionHeader';
import { ProjectCard } from '../components/shared/ProjectCard';
import { FilterBar } from '../components/shared/FilterBar';
import { Lightbox } from '../components/shared/Lightbox';
export function PortfolioPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const projects = [{
    title: 'NSCDC Equipment Supply - July 2024',
    client: 'NSCDC',
    value: '₦90,000,000',
    category: 'procurement',
    image: 'https://cdn.magicpatterns.com/uploads/wn96UApG3KgtjvWxqmpiuP/FDF_GOLD_NSCDC_SUPPLY_PIX.jpg',
    images: ['https://cdn.magicpatterns.com/uploads/wn96UApG3KgtjvWxqmpiuP/FDF_GOLD_NSCDC_SUPPLY_PIX.jpg', 'https://cdn.magicpatterns.com/uploads/fppPS22C82BTBKaoWMyjRh/FDF_GOLD_NSCDC_SUPPLY_PIX_2.jpg', 'https://cdn.magicpatterns.com/uploads/6ZvbRrBNZHL5bD6oTxX7Zx/FDF_GOLD_NSCDC_SUPPLY_PIX_3.jpg']
  }, {
    title: 'Consultancy Contract for 2023 Census Songs',
    client: 'NPC',
    value: '₦12,000,000',
    category: 'consultancy',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80']
  }, {
    title: 'Dog Feed Supply Contract',
    client: 'NSCDC',
    value: '₦35,120,000',
    category: 'procurement',
    image: 'https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?w=1200&q=80']
  }, {
    title: 'Presidential Accommodation Project',
    client: 'NSCDC',
    value: '₦76,923,000',
    category: 'construction',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&q=80']
  }, {
    title: 'Pistol Spray Gun Supply',
    client: 'NSCDC',
    value: '₦90,000,000',
    category: 'procurement',
    image: 'https://images.unsplash.com/photo-1582139329536-e7284fece509?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1582139329536-e7284fece509?w=1200&q=80']
  }, {
    title: 'Mace Imperial Cannister Supply',
    client: 'NSCDC',
    value: '₦88,000,000',
    category: 'procurement',
    image: 'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=1200&q=80']
  }, {
    title: 'Agag Tactical Bomb Suite',
    client: 'NSCDC',
    value: '₦98,800,000',
    category: 'procurement',
    image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=1200&q=80']
  }, {
    title: 'Beret Supply Contract',
    client: 'NSCDC',
    value: '₦70,000,000',
    category: 'procurement',
    image: 'https://images.unsplash.com/photo-1618172193622-ae2d025f4032?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1618172193622-ae2d025f4032?w=1200&q=80']
  }, {
    title: 'Hard Nut Micro Metallic Hand Shield',
    client: 'NSCDC',
    value: '₦92,211,840',
    category: 'procurement',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80',
    images: ['https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1200&q=80']
  }];
  const filterOptions = [{
    value: 'all',
    label: 'All Projects'
  }, {
    value: 'construction',
    label: 'Construction'
  }, {
    value: 'procurement',
    label: 'Procurement'
  }, {
    value: 'consultancy',
    label: 'Consultancy'
  }];
  const filteredProjects = activeFilter === 'all' ? projects : projects.filter(p => p.category === activeFilter);
  const handleProjectClick = (project: any) => {
    setSelectedProject(project);
    setCurrentImageIndex(0);
    setLightboxOpen(true);
  };
  return <div className="min-h-screen pt-20" data-id="element-450">
      <SectionHeader title="Project Portfolio" subtitle="Showcasing our commitment to excellence through completed projects" data-id="element-451" />

      <section className="py-16 sm:py-20 md:py-24" data-id="element-452">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-453">
          <FilterBar options={filterOptions} activeFilter={activeFilter} onFilterChange={setActiveFilter} data-id="element-454" />

          <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-455">
            {filteredProjects.map((project, index) => <motion.div key={project.title} layout initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} data-id="element-456">
                <ProjectCard title={project.title} client={project.client} value={project.value} image={project.image} index={index} onClick={() => handleProjectClick(project)} data-id="element-457" />
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {selectedProject && <Lightbox isOpen={lightboxOpen} onClose={() => setLightboxOpen(false)} images={selectedProject.images} currentIndex={currentImageIndex} onNavigate={setCurrentImageIndex} title={selectedProject.title} data-id="element-458" />}
    </div>;
}